"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _flow2 = _interopRequireDefault(require("lodash/fp/flow"));

var _propOr2 = _interopRequireDefault(require("lodash/fp/propOr"));

var _isArray2 = _interopRequireDefault(require("lodash/fp/isArray"));

var _normalize = _interopRequireDefault(require("./normalize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(schema) {
  return function (originalData, _a) {
    var payload = _a.payload;
    return (0, _flow2.default)((0, _normalize.default)((0, _isArray2.default)(payload) ? [schema] : schema), (0, _propOr2.default)({}, "entities." + schema.key))(payload);
  };
};

exports.default = _default;